import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { UpdateProductRequest } from './update-product.request';

@Injectable({ providedIn: 'root' })
export class UpdateProductUseCase extends UseCase<UpdateProductRequest, Observable<HttpResponse<unknown>>> {

    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
    private _updateProductUrl = '/admin/updateproduct';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: UpdateProductRequest): Observable<HttpResponse<unknown>> | void {
        return this._apiRequestService.sendRequest<UpdateProductRequest, HttpResponse<unknown>>(
            this._storeBaseUrl,
            request,
            true,
            this._updateProductUrl,
            true
        );
    }
}
